let Capacitor = null;
try {
  Capacitor = require('@capacitor/core').Capacitor;
} catch {
  // Capacitor not installed yet — web-only mode
}

export function getPlatform() {
  if (Capacitor?.isNativePlatform?.()) {
    return Capacitor.getPlatform(); // 'ios' | 'android'
  }
  return 'web';
}

export function isNative() {
  return Capacitor?.isNativePlatform?.() || false;
}

export function isIOS() {
  return getPlatform() === 'ios';
}

export function isAndroid() {
  return getPlatform() === 'android';
}

export function isWeb() {
  return getPlatform() === 'web';
}

export function canShowStripeCheckout() {
  return !isNative();
}

export function canShowAppleIAP() {
  return isIOS();
}

export function getPaymentProvider() {
  const platform = getPlatform();
  if (platform === 'ios') return 'apple';
  if (platform === 'android') return 'google';
  return 'stripe';
}
